var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"info",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }